<app-header></app-header>

<div class="custom_scrollbar">
  <div>
    <!-- Section 1: Detailed Description -->
    <!-- Hero Section -->

    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 4rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3">
              <i class="bi bi-lightbulb"></i> Smart AI
            </span>
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                Smart AI. Any Industry
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                No matter your domain, <strong>ConnectNow</strong> enhances
                customer interactions with intelligent automation. Whether
                you're in healthcare, education, retail, or services, our AI
                adapts to your workflows—making engagement smarter, faster, and
                more effective.
                <br />
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!-- Section 2: Features Grid -->
    <div class="pt-5 pb-5 w-100">
      <div class="container">
        <div class="row g-4 justify-content-center">
          <!-- Feature 1 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-lightning-charge fs-1 text-primary"></i>
              </div>
              <h5 class="fw-semibold">Instant Lead Capture</h5>
              <p class="text-muted">
                Capture potential customers instantly through intelligent AI
                chat, and engagement tools.
              </p>
            </div>
          </div>

          <!-- Feature 2 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-calendar-check fs-1 text-success"></i>
              </div>
              <h5 class="fw-semibold">Appointment Scheduling</h5>
              <p class="text-muted">
                Let AI handle scheduling and reminders so your team can focus on
                delivering value.
              </p>
            </div>
          </div>

          <!-- Feature 3 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-people fs-1 text-warning"></i>
              </div>
              <h5 class="fw-semibold">Convert Visitors</h5>
              <p class="text-muted">
                Turn casual website visitors into loyal customers with real-time
                AI-driven engagement.
              </p>
            </div>
          </div>

          <!-- Feature 4 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-gear fs-1 text-danger"></i>
              </div>
              <h5 class="fw-semibold">Industry Workflows</h5>
              <p class="text-muted">
                Pre-built workflows tailored to your industry, ensuring seamless
                integration with your operations.
              </p>
            </div>
          </div>

          <!-- Feature 5 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-robot fs-1 text-info"></i>
              </div>
              <h5 class="fw-semibold">24/7 Virtual Assistant</h5>
              <p class="text-muted">
                Always available to answer questions, capture leads, and assist
                customers around the clock.
              </p>
            </div>
          </div>

          <!-- Feature 6 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-translate fs-1 text-primary"></i>
              </div>
              <h5 class="fw-semibold">Multi-Language Support</h5>
              <p class="text-muted">
                Connect with global audiences by communicating in multiple
                languages effortlessly.
              </p>
            </div>
          </div>

          <!-- Feature 7 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-bar-chart-line fs-1 text-success"></i>
              </div>
              <h5 class="fw-semibold">Analytics & Insights</h5>
              <p class="text-muted">
                Get actionable insights into customer behavior, conversions, and
                engagement trends.
              </p>
            </div>
          </div>

          <!-- Feature 8 -->
          <div class="col-md-6 col-lg-3">
            <div class="card feature-card shadow-sm h-100 text-center p-4">
              <div class="icon mb-3">
                <i class="bi bi-plug fs-1 text-warning"></i>
              </div>
              <h5 class="fw-semibold">Seamless Integrations</h5>
              <p class="text-muted">
                Integrates with CRM and your favorite tools to keep workflows
                smooth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
